import { Organization } from './organization';

export class Credentials {
  username = '';
  password = '';
  organization: Organization;
}
